import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { UserContext } from '../App';

// Narrower than withAdminRights: corporate ADMIN users are turned away.
const withOnwardAdminRights = (Component) => (props) => {
    const navigate = useNavigate();

    const { user } = useContext(UserContext);
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        if (user) {
            if (user.roles?.['ONWARD_ADMIN']) {
                setAuthorized(true);
            } else {
                navigate('/account');
            }
        }
    }, [user]);

    return authorized ? <Component {...props} /> : null;
};

export default withOnwardAdminRights;
